import { Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { OrderModel } from "../../../orders/models/OrderModel";
import OrderDetailView from "../../../orders/views/users/OrderDetailView";
import { ShortPaymentModel } from "../../models/PaymentModels";
import { usePaymentVM } from "../../viewmodels/PaymentVM";
import PaymentDetailView from "./PaymentDetailView";
import PaymentGridView from "./PaymentGridView";

export default function PaymentView() {
    const hasLoaded = useRef(false);
    const vm = usePaymentVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const onCompletedDetail = () => {
        //if (window.confirm("Would you like to refresh the data?")) {
        //    vm.getList();
        //}

        vm.setShowDetail(false);
    }

    const headerView = () => {
        return <div className="left pv-10 ph-15 font-title">
            Payments
        </div>;
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <PaymentGridView
                    invoices={vm.payments}
                    key={vm.listHash}
                    onDetail={(payment: ShortPaymentModel) => {
                        vm.setShowDetail(true);
                        vm.setPayment(payment);
                    }}
                />
            </div>
        </div>;
    }

    const onOrderDetail = (order: OrderModel) => {
        vm.setSelectedOrder(order);
        vm.setShowOrderDetail(true);
    }

    const onCloseOrderDetail = () => {
        vm.setSelectedOrder(null);
        vm.setShowOrderDetail(false);
    }

    return <>
        {mainContent()}

        {vm.showDetail && vm.payment !== null && <>
            <PaymentDetailView
                id={vm.payment.id}
                onClose={onCompletedDetail}
                onOrderDetail={onOrderDetail}
            />
        </>}

        {vm.showOrderDetail && vm.selectedOrder !== null && <>
            <OrderDetailView
                order={vm.selectedOrder}
                onClose={onCloseOrderDetail}
                onDelete={() => { }}
                onPlaceOrder={() => { }}
                onInvoiceDetail={() => { }}
            />
        </>}
    </>;
}